import axios from '../../api/axiosInstance';

export const RECEIVED_DATA_SUCCESS = 'RECEIVED_DATA_SUCCESS';
export const RECEIVING_DATA = 'RECEIVING_DATA';

// Guard against stale responses using a simple request token per dispatch
let analyticsRequestSeq = 0;

export function receiveDataRequest() {
    return (dispatch, getState) => {
        dispatch(receivingData());
        try {
            const stateBefore = getState?.() || {};
            const currentUserBefore = stateBefore.auth?.currentUser || null;
            const expectedServiceId = currentUserBefore?.active_service?.service_id || null;
            const params = {};
            // Don't pass service parameter to avoid backend permission issues
            // if (expectedServiceId) params.service = expectedServiceId;

            const seq = ++analyticsRequestSeq;
            axios.get('/Detection/', { params }).then(res => {
              // Drop stale responses that don't match the latest active service
              const stateAfter = getState?.() || {};
              const currentUserAfter = stateAfter.auth?.currentUser || null;
              const nowServiceId = currentUserAfter?.active_service?.service_id || null;
              if (String(nowServiceId || '') !== String(expectedServiceId || '')) return;
              // Also ensure this is the latest request
              if (seq !== analyticsRequestSeq) return;
              dispatch(receiveDataSuccess(res.data));
            }).catch((error) => {
              // If 403 error, don't make fallback call to avoid duplicate requests
              if (error.response?.status === 403) {
                return;
              }
              // Only make fallback call for other errors
              const fallbackSeq = ++analyticsRequestSeq;
              axios.get('/Detection/').then(res => {
                if (fallbackSeq !== analyticsRequestSeq) return;
                dispatch(receiveDataSuccess(res.data));
              }).catch(() => {});
            });
        } catch (e) {
            // Fallback: still try without params
            const seq = ++analyticsRequestSeq;
            axios.get('/Detection/').then(res => {
              if (seq !== analyticsRequestSeq) return;
              dispatch(receiveDataSuccess(res.data));
            }).catch(() => {});
        }
    };
}

export function receiveDataSuccess(payload) {
    return {
        type: RECEIVED_DATA_SUCCESS,
        payload
    }
}

export function receivingData() {
    return {
        type: RECEIVING_DATA
    }
}
